define('app/views/travel_search_hotel_view',['app/setup',
    'jquery.sumoselect',
    'app/lib/pwt/persian-date',
    'app/lib/pwt/persian-datepicker',
    'app/collections/travel_hotel_collection',
    'app/views/simple_slider'],
  function (takhfifan, sumoSelect, persianDate, pdp) {
    takhfifan.travelSearchHotelView = Backbone.View.extend({
      events: {
        'submit form': 'searchFormSubmit',
        'click .opt': 'dropDownSetModelData',
        'change #travelSearch': 'textInputSetModelDataCityName'
      },

      hotelResultsTemplate: ($('#travel-hotel-cards').length > 0) ?
        _.template($('#travel-hotel-cards').html()) : '',

      initialize: function () {
        var _this = this;
        window.persianDate = persianDate;
        Backbone.Validation.bind(this);

        this.generateSelectBoxes();
        this.generateDatePickers();
        this.collection = new takhfifan.TravelHotelCollection;
        this.sort = "sortOrder";
        this.filters = {};
        this.currentPage = 0;
        this.pageSize = 20;

        this.setDefaultSearchInputs();

        takhfifan.eventHub.on('travel:persist-hotel', function (data) {
          this.persistData(data);
        }, this);
        takhfifan.eventHub.on('travel:hotel-render-search-result', function (collection) {
          takhfifan.eventHub.trigger('travel:persist-hotel', {hotels: collection.collection.toJSON()});
          this.renderSearchHotelResults();
        }, this);
        $(document).on('change', '.tkh-travel-hotel-sort', function (e) {
          var $target = $(e.target);
          _this.currentPage = 0;
          _this.sort = $target.find(":selected").val();
          _this.renderSearchHotelResults(false);
        });

        $(document).on('change', '.tkh-travel-hotel-filter', function (e) {
          var $target = $(e.target);
          if ($target.is(":checked")) {
            _this.filters[$target.data('key')].push($target.data('val'))
          } else {
            _this.filters[$target.data('key')] = _.without(_this.filters[$target.data('key')], $target.data('val'))
          }

          _this.currentPage = 0;
          _this.renderSearchHotelResults(false);
        });

        $(document).on('change', '.tkh-nights-in-search-page', function (e) {
          var $target = $(e.target);
          _this.model.set({nights: $target.find(":selected").val()})
        });

        $(document).on('click', '.tkh-travel-hotel-results__show-more', function (e) {
          _this.currentPage++;
          $(this).remove();
          _this.renderSearchHotelResults(true);
        });
      },

      generateSelectBoxes: function () {
        this.$('select.tkh-travel-hotel-search__txt').SumoSelect({
          search: true,
          showTitle: true,
          noMatch: 'موردی یافت نشد.',
          searchText: 'جستجو کنید...',
          allowFreeSearch: true
        });
        this.$('select.tkh-travel-hotel-search__number').SumoSelect();
      },

      setDefaultSearchInputs: function () {
        const dates = this.generateDate(true, 1);
        this.model.set({checkin: dates.date, checkinJalali: dates.jalali, nights: 1});
        $(".search-el-in").html(this.model.get('checkinJalali').replace(/\-/g, '/')).addClass('travel-search-types__form__dp--has-value');
      },

      formatDate: function (unix) {
        var currentDate = new Date(unix);
        return (currentDate.getFullYear() + "-" + this.addLeadingZero(currentDate.getMonth() + 1) + "-" + this.addLeadingZero(currentDate.getDate()));
      },

      addLeadingZero: function (n) {
        var s = "0" + n;
        return s.substr(s.length - 2);
      },

      generateDatePickers: function () {
        var _this = this,
          dpOptions = {
            onSelect: function (unix) {
              var selectedDate = this.model.state.selected,
                $placeHolder = $(this.model.inputElement),
                selectedDateText = _this.formatDate(unix),
                selectedDateJalali = new persianDate(unix).format("YYYY-MM-DD");

              $placeHolder.html(selectedDate.year + "/" + selectedDate.month + "/" + selectedDate.date);
              $placeHolder.addClass('travel-search-types__form__dp--has-value');

              if ($placeHolder.data("type") === "in") {
                _this.model.set({checkin: selectedDateText, checkinJalali: selectedDateJalali});
                _this.model.setNights();
                _this.validateForm();

                _this.checkInDP.touched = true;
                if (_this.checkOutDP && _this.checkOutDP.options && _this.checkOutDP.options.minDate != unix) {
                  var cachedValue = _this.checkOutDP.getState().selected.unixDate;
                  _this.checkOutDP.options = {minDate: unix + 86400000};
                  if (_this.checkOutDP.touched) {
                    _this.checkOutDP.setDate(cachedValue);
                  }
                }

              } else {
                _this.model.set({checkout: selectedDateText, checkoutJalali: selectedDateJalali});
                _this.model.setNights();
                _this.validateForm();

                _this.checkOutDP.touched = true;
                if (_this.checkInDP && _this.checkInDP.options && _this.checkInDP.options.maxDate != unix) {
                  var cachedValue = _this.checkInDP.getState().selected.unixDate;
                  _this.checkInDP.options = {maxDate: unix - 86400000};
                  if (_this.checkInDP.touched) {
                    _this.checkInDP.setDate(cachedValue);
                  }
                }
              }
            },
            minDate: new Date(),
            maxDate: null,
            autoClose: true,
            toolbox: {
              calendarSwitch: {
                enabled: false
              }
            }
          };

        var $datePickers = this.$(".tkh-travel-hotel-date-picker");
        $datePickers.each(function () {
          $(this).removeClass('travel-search-types__form__dp--has-value');
          $(this).html($(this).data("ph"));
        });

        if (this.checkInDP) {
          this.checkInDP.options = dpOptions;
        }
        if (this.checkOutDP) {
          this.checkOutDP.options = dpOptions;
        }
        if (!this.checkOutDP || !this.checkInDP) {
          $datePickers.each(function () {
            var dp = $(this).pDatepicker(dpOptions);
            if ($(this).data("type") === "in") {
              _this.checkInDP = dp;
            } else {
              _this.checkOutDP = dp;
            }
          });
        }
      },
      setModelData:function(cityId,cityName){
        var attrs = {};
        attrs['cityId'] = cityId;
        attrs['cityName'] = cityName;
        this.model.set(attrs);
        this.validateForm();
      },
      dropDownSetModelData: function (e) {
        var $this = $(e.target);
        var cityId = $this.attr('data-city-id'),
            cityName = $this.attr('data-city-name');
        $("#travelSearch").val(cityName);
        this.setModelData(cityId,cityName)
      },

      textInputSetModelDataCityName: function(e){
        var $this = $(e.target),
            _that=this;
        var cityName = $this.val(),
            cityId = "0";
        $('.opt').each(function(){
          if($(this).attr('data-city-name') === cityName){
            cityId = $(this).attr('data-city-id');
            return false;
          }
        });
        _that.setModelData(cityId,cityName);

      },

      validateForm: function () {
        this.model.validate();
        if (this.model.isValid()) {
          this.$('.travel-search__btn').removeAttr('disabled');
        } else {
          this.$('.travel-search__btn').attr('disabled', 'disabled');
        }
      },

      // helper for date generation with 2 parameters that returns an object
      generateDate: function (isNow, whenFromNowInDays) {
        var unix = new Date();
        if (!isNow) {
          unix.setDate(unix.getDate() + whenFromNowInDays);
        }
        var selectedDateText = this.formatDate(unix),
          selectedDateJalali = new persianDate(unix).format("YYYY-MM-DD");

        return {date: selectedDateText, jalali: selectedDateJalali};
      },

      searchFormSubmit: function (e) {
        e.preventDefault();
        takhfifan.eventHub.trigger('travel:disable');
        takhfifan.eventHub.trigger('travel:persist-hotel', {search: this.model});
        this.sendAjaxRequest();
      },

      persistData: function (data) {
        var persistedData = Lockr.get("travelHotelData") || {};
        _.each(data, function (value, key) {
          persistedData[key] = value;
        });
        persistedData.time = new Date();
        Lockr.set("travelHotelData", persistedData);
      },

      sendAjaxRequest: function () {
        var _this = this;
        this.collection.fetch({
          dataType: 'json',
          data: {
            city_id: this.model.get('cityId'),
            cityName: this.model.get('cityName'),
            form_key: takhfifan.formKey
          },
          success: function (collection) {
            _.each(collection.filters, function (filter, key) {
              _this.filters[key] = [];
            });
            if (
              collection.models &&
              collection.models.length > 0 &&
              collection.hasOnline) {
              collection.getRoomDetails(null, collection.models, 'travel:hotel-render-search-result');
            } else {
              takhfifan.eventHub.trigger('travel:hotel-render-search-result', {collection: collection});
            }
          },
          error: function () {
          },
          complete: function () {
          }
        })
      },

      renderSearchHotelResults: function (append) {
        var _this = this,
          models = this.collection.toJSON();
        takhfifan.eventHub.trigger('travel:enable');
        if (!models) {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'جستجوی شما نتیجه ای در بر نداشت!'
          });
        } else {
          models = _.filter(models, function (model) {
            var shouldShown = true;
            _.each(_this.filters, function (list, key) {
              if (list.length > 0) {
                if (_.indexOf(list, model[key]) === -1) {
                  shouldShown = false;
                }
              }
            });
            return shouldShown;
          });

          models = _.map(models, function (model) {
            model['isUnAvailable'] = model.price === 0;
            return model;
          });

          if (this.sort) {
            models = _.sortBy((_.sortBy((_.sortBy(models, function (model) {
              return _this.sort === "sortOrder" ? model.sort_order : (_this.sort === "asc"? model.price :(_this.sort === "dsc" ? -model.price : model.sort_order ));
            })), 'isUnAvailable')), "isOnline");
          }

          $('.travel-hotels-results').removeClass('travel-hotels-results--no-result');
          $('.landingSection').css('display', 'none');

          var numberOfPages = Math.ceil(models.length / _this.pageSize) - 1;
          // models = _.rest(models, (_this.currentPage) * _this.pageSize);
          models = _.first(models, _this.pageSize * (_this.currentPage + 1));

          if (!append) {
            $('.tkh-travel-hotels-results__hotels').html('');
          }

          var persistedData = Lockr.get('travelHotelData');
          $('.tkh-travel-hotels-results__hotels').html(
            _this.hotelResultsTemplate({
              hotels: models,
              search: persistedData.search,
              filters: _this.collection.filters,
              activeFilters: _this.filters,
              sort: _this.sort,
              showMore: _this.currentPage < numberOfPages
            })
          );
          takhfifan.eventHub.trigger('travel:enable');
          var $emptyResultNavButt = $('.tkh-travel-hotel__nav-travel-index');
          if ($emptyResultNavButt) {
            $emptyResultNavButt.on('click', function () {
              _this.redirectToTravelIndex();
            });
          }
          var isSmallDevice = $(window).width() < 980 ? true : false;
          if (isSmallDevice) {
            $('.sidebar').addClass('collapsed');
          }
          else {
            $('.collapse-arrow').addClass('hide');
          }
          $('.collapse-arrow').click(function () {
            $('.sidebar').toggleClass('collapsed');
            $('.collapse-arrow').toggleClass('open');
          });


          $('.tkh-travel-search-types__results').hide();
          $('.tkh-travel-hotels-results-').show();

          if(isSmallDevice){
            window.scrollTo(0, 500); 
            // var element = document.getElementById("travelResultContent");
            // if(element){
            //   $('body').scrollTo('#travelResultContent');
            // }
            // else{
            //   $('body').scrollTo('#travelEmptyResultContent');
            // }
          }

          setTimeout(function () {
            $('.tkh-slider').each(function () {
              new takhfifan.simpleSlider({
                el: $(this)
              });
            });
          }, 1000);
        }
      },

      redirectToTravelIndex: function () {
        var location = this.trimString(this.model.get('cityName'));
        var route = "travel_search/location/" + encodeURIComponent(location);
        takhfifan.travelSearchRoute.navigate(route, {trigger: true, replace: false});
        window.scrollTo(0, 0);
      },

      trimString: function (s) {
        if (String.prototype.trim) {
          return s.trim();
        } else {
          return s.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
      },
    });


  });

